import React, {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './DotMarker.module.css';
import Label from "../Label";
import markerCss from "../Marker.module.css";
import {minZoomForLevel17} from "../../../utils/s2";


const DotMarker = (props) => {
	const circle = useRef(null);

	useEffect(() => {
		circle.current = new window.maps.Circle({
				strokeColor: '#666666',
				fillColor: props.color,
				strokeWidth: 0,
				strokeOpacity: 0,
				fillOpacity: 0.2,
				map: window.map,
				center: new window.maps.LatLng(props.lat, props.lng),
				radius: 20
			});

		return () => {
			if( circle.current )
				circle.current.setMap(null);
		} // eslint-disable-next-line
	}, []);

	if( props.zoom < minZoomForLevel17 )
		return null;

	return (<div className={markerCss.Marker}>
		{props.infoWindow}
		<svg height="15" width="15" className={css.DotMarker} onClick={() => props.onClick(props.portal)}>
			<circle cx="7" cy="7" r="5" strokeWidth="0" fill={props.color} />
		</svg>
		{props.zoom > 17 && <Label classes={[css.Label]} text={props.name} />}
	</div>);
};

DotMarker.propTypes = {
	color: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
	return {
		zoom: state.map.zoom
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DotMarker);